<div class="bp-modal mod-lg">
	<bp-modal-header>
		<a left (click)="onClickBack()" (keydown.enter)="onClickBack()" [tabIndex]="0">{{ "back" | translate }}</a>
		<a right (click)="closeAll()" (keydown.enter)="closeAll()" [tabIndex]="0">{{ "close" | translate }}</a>
	</bp-modal-header>
	<div class="bp-modal-body content-container">
		<header>
			<h2 class="header">{{ "deposit_sepa_proper_account_reminder_title" | translate }}</h2>
		</header>
		<p class="text">{{ "deposit_sepa_proper_account_reminder_text" | translate }}</p>
		<section class="actions">
			<button class="btn btn-primary actions__ok" type="button" (click)="onClickSubmit()">
				{{ "Continue" | translate }}
			</button>
			<a (click)="onClickCancelDeposit()">
				{{ "cancel_deposit" | translate }}
			</a>
		</section>
	</div>
</div>
